import React from "react"
import PropTypes from "prop-types"

export const GroupMessages = ({ height = 24, width = 24, fill = "#272A34", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 87 57" fill={fill} xmlns="http://www.w3.org/2000/svg"  {...props}>
    <path
      d="M86.4181 55.3746L3.01977 56.5467L1.30859 4.09777L83.8923 1.45898L85.4501 24.9402L86.5552 25.3924L86.4181 55.3746Z"
      fill="#000066"
    />
    <path d="M85.3595 54.3286L1.96117 56.9673L0.25 2.8888L83.6484 0.25L85.3595 54.3286Z" fill={fill} />
    <path
      d="M1.96063 56.9673L1.93227 56.0708C1.87523 54.2693 2.76553 52.5695 4.27886 51.5906L42.7441 26.709L82.7054 49.1091C84.2775 49.9902 85.2736 51.6304 85.3306 53.432L85.359 54.3285L1.96063 56.9673Z"
      fill={fill}
    />
    <path
      d="M0.25 2.88863L0.280638 3.85992C0.342403 5.81148 1.34287 7.59094 2.91747 8.54968L42.9412 32.9209L81.344 6.06832C82.8549 5.01195 83.7408 3.17285 83.6792 1.22129L83.6485 0.25L82.0599 1.69097L1.73807 4.23231L0.25 2.88863Z"
      fill="#000066"
    />
    <path
      d="M0.25 2.88895L0.278357 3.78545C0.335396 5.58691 1.33146 7.22686 2.90362 8.10836L42.8289 29.3681L81.3303 5.62667C82.8436 4.64771 83.7341 2.94795 83.6769 1.14649L83.6485 0.25L0.25 2.88895Z"
      fill={fill}
    />
  </svg>
)

GroupMessages.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string // Add validation for the 'fill' prop
}
